import { render } from "./ListeClassePage.vue?vue&type=template&id=8f0ef5ce&ts=true"
import script from "./ListeClassePage.vue?vue&type=script&lang=ts"
export * from "./ListeClassePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__